export enum LanguageISO2Enum {
  RU = 'RU',
}
